import React from "react"
import Featured from "./featuredServices/Featured"
import Hero from "./hero/Hero"
import Room from "./room/Room"
import AboutTeaser from "./about/AboutTeaser"
import GalleryTeaser from "./gallery/GalleryTeaser"
import WorksNotice from "../common/worksNotice/WorksNotice"
import ContactSection from "../contact/ContactSection"

const Home = () => {
  return (
    <>
      <WorksNotice />
      <Hero />
      <AboutTeaser />
      <Room />
      <Featured />
      <GalleryTeaser />
      <ContactSection />
    </>
  )
}

export default Home
